var _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 30.848,
    width: 25.4399,
    x: 7,
    y: 5.59998
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_4_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_10",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.12 9.6h12.32l-.64 3.264h-9.344l-1.664 5.28.064.064c.6187-.4693 1.2693-.8 1.952-.992.704-.192 1.44-.288 2.208-.288.96 0 1.824.1707 2.592.512.7893.32 1.4507.7787 1.984 1.376.5547.5973.9813 1.3013 1.28 2.112.2987.7893.448 1.6533.448 2.592 0 1.344-.224 2.5707-.672 3.68-.448 1.088-1.0773 2.0267-1.888 2.816-.8107.768-1.7707 1.3653-2.88 1.792s-2.3147.64-3.616.64c-1.0667 0-2.048-.1493-2.944-.448-.896-.2773-1.664-.6933-2.304-1.248-.64-.576-1.1413-1.28-1.504-2.112-.3413-.8533-.4907-1.8453-.448-2.976h3.648c.064 1.216.3947 2.144.992 2.784s1.536.96 2.816.96c.7467 0 1.4293-.1387 2.048-.416.64-.2773 1.184-.6507 1.632-1.12.4693-.4907.832-1.056 1.088-1.696s.384-1.3333.384-2.08c0-1.408-.3627-2.4747-1.088-3.2-.704-.7253-1.632-1.088-2.784-1.088-.896 0-1.696.1813-2.4.544-.6827.3413-1.2587.832-1.728 1.472h-3.232z",
    fill: "#00c271"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo5);
export default __webpack_public_path__ + "static/media/no_5.3a1b5c47ad9b77488462b22a3206bc25.svg";
export { ForwardRef as ReactComponent };